import { Directive, ElementRef, HostListener, Input } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TooltipDirective = (function () {
    /* tslint:enable */
    function TooltipDirective(elementRef) {
        this.elementRef = elementRef;
        this.tooltipOffset = 8;
        /* tslint:disable:no-input-rename */
        this.tooltipText = '';
        this.placement = 'top';
        this.delay = 0;
        this.showDelay = 0;
        this.hideDelay = 300;
        this.zIndex = false;
        this.hover = true;
    }
    /**
     * @return {?}
     */
    TooltipDirective.prototype.onMouseEnter = /**
     * @return {?}
     */
    function () {
        if (!this.hover) {
            return;
        }
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
        }
        this.getElemPosition();
        if (this.tooltip) {
            this.tooltip.classList.add('ng-tooltip-show');
        }
        else {
            this.create();
            this.setPosition();
            this.show();
        }
    };
    /**
     * @return {?}
     */
    TooltipDirective.prototype.onMouseLeave = /**
     * @return {?}
     */
    function () {
        if (this.hover) {
            this.hide();
        }
    };
    /**
     * @return {?}
     */
    TooltipDirective.prototype.onClick = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.hideTimeoutId) {
            clearTimeout(this.hideAfterClickTimeoutId);
            clearTimeout(this.hideTimeoutId);
        }
        this.getElemPosition();
        if (this.tooltip) {
            this.tooltip.classList.add('ng-tooltip-show');
        }
        else {
            this.create();
            this.setPosition();
            this.show();
        }
        this.hideAfterClickTimeoutId = window.setTimeout(function () {
            _this.hide();
        }, this.hideDelay);
    };
    /**
     * @return {?}
     */
    TooltipDirective.prototype.getElemPosition = /**
     * @return {?}
     */
    function () {
        this.elemPosition = this.elementRef.nativeElement.getBoundingClientRect();
    };
    /**
     * @return {?}
     */
    TooltipDirective.prototype.create = /**
     * @return {?}
     */
    function () {
        this.showDelay = this.delay || this.showDelay;
        this.tooltip = document.createElement('span');
        this.tooltip.className += 'ng-tooltip ng-tooltip-' + this.placement;
        this.tooltip.textContent = this.tooltipText;
        if (this.zIndex) {
            this.tooltip.style.zIndex = this.zIndex;
        }
        document.body.appendChild(this.tooltip);
    };
    /**
     * @return {?}
     */
    TooltipDirective.prototype.show = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.showTimeoutId) {
            clearTimeout(this.showTimeoutId);
        }
        this.showDelay = this.delay || this.showDelay;
        this.showTimeoutId = window.setTimeout(function () {
            if (_this.tooltip) {
                _this.tooltip.className += ' ng-tooltip-show';
            }
        }, this.showDelay);
    };
    /**
     * @return {?}
     */
    TooltipDirective.prototype.hide = /**
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.showTimeoutId);
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
        }
        if (this.tooltip) {
            this.tooltip.classList.remove('ng-tooltip-show');
            this.hideTimeoutId = window.setTimeout(function () {
                _this.tooltip.parentNode.removeChild(_this.tooltip);
                _this.tooltip = null;
            }, this.hideDelay);
        }
    };
    /**
     * @return {?}
     */
    TooltipDirective.prototype.setPosition = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ elemHeight = this.elementRef.nativeElement.offsetHeight;
        var /** @type {?} */ elemWidth = this.elementRef.nativeElement.offsetWidth;
        var /** @type {?} */ tooltipHeight = this.tooltip.clientHeight;
        var /** @type {?} */ tooltipWidth = this.tooltip.offsetWidth;
        var /** @type {?} */ scrollY = window.pageYOffset;
        if (this.placement === 'top') {
            this.tooltip.style.top = (this.elemPosition.top + scrollY) - (tooltipHeight + this.tooltipOffset) + 'px';
        }
        if (this.placement === 'bottom') {
            this.tooltip.style.top = (this.elemPosition.top + scrollY) + elemHeight + this.tooltipOffset + 'px';
        }
        if (this.placement === 'top' || this.placement === 'bottom') {
            this.tooltip.style.left = (this.elemPosition.left + elemWidth / 2) - tooltipWidth / 2 + 'px';
        }
        if (this.placement === 'left') {
            this.tooltip.style.left = this.elemPosition.left - tooltipWidth - this.tooltipOffset + 'px';
        }
        if (this.placement === 'right') {
            this.tooltip.style.left = this.elemPosition.left + elemWidth + this.tooltipOffset + 'px';
        }
        if (this.placement === 'left' || this.placement === 'right') {
            this.tooltip.style.top = (this.elemPosition.top + scrollY) + elemHeight / 2 - this.tooltip.clientHeight / 2 + 'px';
        }
    };
    TooltipDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[tooltip]'
                },] },
    ];
    /** @nocollapse */
    TooltipDirective.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    TooltipDirective.propDecorators = {
        "tooltipText": [{ type: Input, args: ['tooltip',] },],
        "placement": [{ type: Input },],
        "delay": [{ type: Input },],
        "showDelay": [{ type: Input, args: ['show-delay',] },],
        "hideDelay": [{ type: Input, args: ['hide-delay',] },],
        "zIndex": [{ type: Input, args: ['z-index',] },],
        "hover": [{ type: Input },],
        "onMouseEnter": [{ type: HostListener, args: ['focusin',] }, { type: HostListener, args: ['mouseenter',] },],
        "onMouseLeave": [{ type: HostListener, args: ['focusout',] }, { type: HostListener, args: ['mouseleave',] },],
        "onClick": [{ type: HostListener, args: ['click', ['$event'],] },],
    };
    return TooltipDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { TooltipDirective };



//////////////////
// WEBPACK FOOTER
// ./~/ng2-tooltip-directive/components.js
// module id = 1019
// module chunks = 4